const home = {
	checking_credentials: "Checking credentials",
	overview_cards: {
		dadup: {
			go_to: "Ga naar daDup overzicht",
			title: "daDup",
		},
		domain: {
			go_to: "Ga naar domein overzicht",
			title: "Domeinen",
		},
		pbs: {
			go_to: "Ga naar PBS overzicht",
			title: "PBS",
		},
		vps: {
			go_to: "Ga naar VPS overzicht",
			title: "VPS'en",
		},
	},
	welcome: "Welkom",
};

export default home;
